import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, Fragment } from 'react';
import { useId } from '@react-aria/utils';
import { MenuWrapper } from './BKJMenu.styled.js';
const NAV_KEYS = new Set(['ArrowDown', 'ArrowUp', 'Home', 'End']);
export const BKJMenu = forwardRef(({ isMenuOpen, closeMenu, children, onKeyDown, ...rest }, ref) => {
    const generatedId = useId();
    const handleKeyDown = (event) => {
        onKeyDown?.(event);
        if (event.key === 'Enter' || event.key === ' ') {
            closeMenu();
            return;
        }
        if (event.defaultPrevented || !NAV_KEYS.has(event.key))
            return;
        event.preventDefault();
        const wrapper = event.currentTarget;
        const target = event.target;
        let next = null;
        if (event.key === 'ArrowDown') {
            next = target.nextElementSibling ?? wrapper.firstElementChild;
        }
        else if (event.key === 'ArrowUp') {
            next = target.previousElementSibling ?? wrapper.lastElementChild;
        }
        else if (event.key === 'Home') {
            next = wrapper.firstElementChild;
        }
        else if (event.key === 'End') {
            next = wrapper.lastElementChild;
        }
        next?.focus();
    };
    return (_jsx(Fragment, { children: isMenuOpen && children && (_jsx(MenuWrapper, { role: "menu", "aria-label": "Menu", id: generatedId, ref: ref, onClick: closeMenu, onKeyDown: handleKeyDown, ...rest, children: children })) }));
});
//# sourceMappingURL=BKJMenu.js.map